import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { trackTermsOfUse } from 'actions';
import { Accept } from 'components/Accept/Accept';
import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import { useTranslations } from 'utils/translations/useTranslations';

type TermsAndConditionProps = ConnectedProps<typeof connector> &
  FlysiteUrls & {
    checked?: boolean;
    error?: string | boolean;
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
  };

function TermsAndConditionsComponent({
  checked,
  error,
  name,
  onChange,
  privacyUrl,
  required,
  termsUrl,
  trackTermsOfUse,
}: TermsAndConditionProps) {
  const i18n = useTranslations();

  const termsOfUseLink = (
    <a
      className="Link"
      href={termsUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="termsOfUseLink"
      onClick={() => trackTermsOfUse('terms of use')}
    >
      {i18n.t('termsAndConditions.terms_of_use')}
    </a>
  );

  const privacyPolicyLink = (
    <a
      className="Link"
      href={privacyUrl}
      target="_blank"
      data-testid="privacyPolicyLink"
      rel="noopener noreferrer"
      onClick={() => trackTermsOfUse('privacy policy')}
    >
      {i18n.t('termsAndConditions.privacy_policy')}
    </a>
  );

  return (
    <Accept
      checked={checked}
      error={error && i18n.t('termsAndConditions.error')}
      onChange={onChange}
      name={name}
      required={required}
    >
      {i18n.t('termsAndConditions.terms_read')} {termsOfUseLink}{' '}
      {i18n.t('termsAndConditions.and')} {privacyPolicyLink}
    </Accept>
  );
}

const mapDispatchToProps = {
  trackTermsOfUse,
};

const connector = connect(null, mapDispatchToProps);

const TermsAndConditions = connector(
  WithFlysiteUrls(TermsAndConditionsComponent),
);

export { TermsAndConditions };
